module.exports = "<div class=\"gw-panel-group\" ng-transclude></div>"